module.exports = __webpack_public_path__ + "img/fuwu1.7fb3f175.jpg";